import { render, staticRenderFns } from "./pays.vue?vue&type=template&id=7a9d08df&scoped=true&"
import script from "./pays.vue?vue&type=script&lang=js&"
export * from "./pays.vue?vue&type=script&lang=js&"
import style0 from "./pays.vue?vue&type=style&index=0&id=7a9d08df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9d08df",
  null
  
)

export default component.exports